import { connect } from 'react-redux';
import AltLine from '../components/AltLine';
import { updateLine, createLine, deleteLine } from '../actions/line';
import {
  addLineToLineGroup,
  selectLineGroupLine,
  removeLineFromLineGroup,
} from '../actions/linegroups';

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  obj: ownProps.line,
  uiToggles: state.ui.toggles,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: (obj) => {
    dispatch(updateLine(obj));
  },
  onCreate: (values) => {
    // TODO
    // dispatch(createAltLine(ownProps.line.id, values));
  },
  onDuplicate: (line, index) => {
    const newLineAction = dispatch(createLine({ ...line, id: undefined }));
    dispatch(addLineToLineGroup(ownProps.linegroup.id, newLineAction.obj.id, index + 1));
  },
  onSelect: () => {
    // if (ownProps.onSelect) {
    ownProps.onSelect(ownProps.line.id);
    // }
    // dispatch(selectLineGroupLine(ownProps.linegroup.id, ownProps.index));
  },
  onRemove: (ev) => {
    ev.preventDefault();
    if (!ownProps.selected) {
      dispatch(removeLineFromLineGroup(ownProps.linegroup.id, ownProps.index));
    }
  },
  onDelete: (ev) => {
    ev.preventDefault();
    if (!ownProps.selected) {
      dispatch(deleteLine(ownProps.line.id));
    }
  },
});

const AltLineContainer = connect(mapStateToProps, mapDispatchToProps)(AltLine);

export default AltLineContainer;



// WEBPACK FOOTER //
// ./src/containers/AltLineContainer.js